import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function CycleRentalComponent() {
	return (
		<div>
			<br />
			<br />
			<Container>
				<Row>
					<Col lg={8} md={12}>
						<iframe
							className="youtube-vid"
							src="https://www.youtube.com/embed/oE3e-jKLKMc?autoplay=0&mute=1&player=html5"
							frameborder="0"
						/>
					</Col>
					<Col lg={4} md={12}>
						<br />
						<br />
						<br />
						<hr className="new4 " />
						<br />
						<br />
						<div className="text-center  slogan-1 display-4">Cycle Rental</div>
						<br />
						<br />
						<hr className="new4 " />
					</Col>
				</Row>
			</Container>
			<Container>
				<Row>
					<Col>
						<br />
						<br />
						<div className="text-center mt-3 slogan-2 font-weight-bold">
							Going for a ride with your cycle gang or planning to try your hands on premium cycles.
							Rent from a wide variety of highly maintained premium cycles
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default CycleRentalComponent;
